import { useCallback, useMemo, useState } from 'react';
import documentsRepository from '../../repositories/documents/documents-repository';
import { useAppSelector } from '../redux';
import { env } from '../../env';
import { getDossierFilterContracts } from '../../store';

export interface AzimutLifeLogic {
  azimutLifeToken: string;
  isRequestError: boolean;
  isRequestLoading: boolean;
  getAzimutLifeAccessToken: () => void;
  clear: () => void;
  showAzimutLife: boolean;
}

export const useAzimutLifeLogic = (): AzimutLifeLogic => {
  const [azimutLifeToken, setAzimutLifeToken] = useState<string>();
  const [isRequestError, setIsRequestError] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const { token } = useAppSelector((state) => state.data.user);
  const AZIMUT_LIFE_CONTRACT_PREFIXES = ['33', '37'];

  const dossierFilter = useAppSelector(
    (state) => state.data.dossier.dossierFilter
  );

  const showAzimutLife = useMemo(() => {
    const contracts = getDossierFilterContracts(dossierFilter) ?? [];
    return contracts.some((contract) =>
      AZIMUT_LIFE_CONTRACT_PREFIXES.some((prefix) =>
        contract.startsWith(prefix)
      )
    );
  }, [dossierFilter]);

  const getAzimutLifeAccessToken = useCallback(() => {
    setIsRequestLoading(true);
    documentsRepository
      .getAzimutLifeAccessToken(token)
      .then((value) => {
        if (env.appModule === 'web') {
          window.open(value, '_blank');
        } else {
          setAzimutLifeToken(value);
        }
        setIsRequestLoading(false);
      })
      .catch((_) => {
        setIsRequestError(true);
        setIsRequestLoading(false);
      });
  }, [token]);

  const clear = useCallback(() => {
    setAzimutLifeToken(undefined);
    setIsRequestError(false);
  }, []);

  return {
    azimutLifeToken,
    isRequestError,
    isRequestLoading,
    getAzimutLifeAccessToken,
    clear,
    showAzimutLife,
  };
};
